import { gql } from '@apollo/client';

export const GET_ONBOARDING = gql`
  query GetOnboarding {
    getOnboarding {
      onboardingJSON
      currentPageId
      status
    }
  }
`;

export const GET_ONBOARDING_FOR_USER = gql`
  query GetOnboardingForUser($userId: String!) {
    getOnboardingForUser(userId: $userId) {
      onboardingJSON
      currentPageId
      status
      userId
    }
  }
`;
